export default __webpack_public_path__ + "src/assets/interact-with-contracts.07cd3cfa8c5119caf9bb0b3c63b15a10.svg";